import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SERVER_API } from '../../fileWithConstants';
import toast from 'react-hot-toast';

const FabricOpeningBalanceRowEdit = ({ initialRows = [], onDataChange }) => {
  const [warehouse, setWarehouse] = useState([]);
  const [rows, setRows] = useState([]);

  // ✅ Set rows only from initialRows
  useEffect(() => {
    if (initialRows.length) {
      setRows(
        initialRows.map(row => ({
          fabric_id: row.fabric_id, // ✅ Keep the existing fabric_id for backend update
          warehouse: row.warehouse || '',
          than_no: row.than_no || '',
          qty: row.qty || '',
          than_cut_qty: row.than_cut_qty || '',
          price: row.price || '',
          amount: (parseFloat(row.qty || 0) * parseFloat(row.price || 0)).toFixed(2)
        }))
      );
    }
  }, [initialRows]);

  const handleRowChange_old = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    const qty = parseFloat(updatedRows[index].qty) || 0;
    const price = parseFloat(updatedRows[index].price) || 0;
    updatedRows[index].amount = (qty * price).toFixed(2);

    setRows(updatedRows);
  };

  const handleRowChange = (index, field, value) => {
  const updatedRows = rows.map((row, i) => {
    if (i !== index) return row;

    const updatedRow = {
      ...row,
      [field]: value
    };

    const qty = parseFloat(field === 'qty' ? value : row.qty) || 0;
    const price = parseFloat(field === 'price' ? value : row.price) || 0;
    updatedRow.amount = qty * price; // numeric value only

    return updatedRow;
  });

  setRows(updatedRows);
};



  const getWareHouse = async () => {
    try {
      const { data } = await axios.get(`${SERVER_API}/api/v1/supplier/get-warehouse`);
      if (data?.success && data?.wdata.length > 0) {
        setWarehouse(data?.wdata);
      } else {
        toast.error('Something went wrong while getting Warehouse data.');
      }
    } catch (error) {
      console.log(error);
    }
  };

 useEffect(() => {
  if (typeof onDataChange === 'function') {
    onDataChange(rows);
  }
}, [JSON.stringify(rows)]);

  useEffect(() => {
    getWareHouse();
  }, []);

  return (
    <>
      <table className="table table-responsive table-hover">
        <thead>
          <tr className="align-item">
            <th>#</th>
            <th className="text-center">Warehouse</th>
            <th className="text-center">Thaan No.</th>
            <th className="text-center">Quantity</th>
            <th className="text-center">Unit</th>
            <th className="text-center">Price</th>
            <th className="text-center">Amount INR</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.fabric_id}>
              <td className="text-center">{index + 1}</td>
              <td className="text-center">
                <select
                  className="form-control"
                  required
                  onChange={(e) => handleRowChange(index, 'warehouse', e.target.value)}
                  value={row.warehouse}
                >
                  <option value="">--Select--</option>
                  {warehouse.map((house) => (
                    <option key={house.id} value={house.id}>
                      {house.name}
                    </option>
                  ))}
                </select>
              </td>
              <td className="text-center">
                <input
                  type="text"
                  className="form-control"
                  value={row.than_no}
                  onChange={(e) => handleRowChange(index, 'than_no', e.target.value)}
                  readOnly={row.qty === row.than_cut_qty}
                  required
                />
              </td>
              <td className="text-center">
                <input
                  type="text"
                  className="form-control"
                  value={row.qty}
                  onChange={(e) => handleRowChange(index, 'qty', e.target.value)}
                  readOnly={row.qty === row.than_cut_qty}
                  required
                />
              </td>
              <td className="text-center">Mtr</td>
              <td className="text-center">
                <input
                  type="text"
                  className="form-control"
                  value={row.price}
                  onChange={(e) => handleRowChange(index, 'price', e.target.value)}
                  readOnly={row.qty === row.than_cut_qty}
                  required
                />
              </td>
              <td className="text-center">
              <input
                type="text"
                className="form-control"
                value={Number(row.amount || 0).toFixed(2)}
                readOnly
              />
            </td>

            </tr>
          ))}
        </tbody>
      </table>

      <p className="text-end fw-bold mt-2">
        Total Amount:{" "}
        {rows.reduce((acc, r) => acc + parseFloat(r.amount || 0), 0).toFixed(2)}
      </p>
    </>
  );
};

export default FabricOpeningBalanceRowEdit;
